import type { EvidenceUploadMode, ModelResults } from 'api';

import { getAnalysisStatusUsingBaleModel } from './getAnalysisStatusUsingBaleModel';
export const getAnalysisStatusUsingGradeService = (
  model_results: ModelResults,
  mode: EvidenceUploadMode
): 'rejected-material' | 'accepted' => {
  if (model_results.accepted === null) {
    // it can happen for model results that were received before Grade Service was introduced
    return getAnalysisStatusUsingBaleModel(model_results, mode);
  }
  return model_results.accepted ? 'accepted' : 'rejected-material';
};
